import { blogPosts } from "@/mocks/blogPosts";
import { Link } from "react-router-dom";

const featured = blogPosts.find((p) => p.featured);

export default function FeaturedPost() {
  if (!featured) return null;

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="inline-flex items-center gap-2 text-[#418b86] text-xs font-medium tracking-widest uppercase mb-8">
          <i className="ri-star-line text-sm"></i>
          Featured Article
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <div className="rounded-2xl overflow-hidden h-72 md:h-[28rem]">
            <img
              src={featured.image}
              alt={featured.title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#e6f6f5] px-4 py-2 rounded-full mb-5">
              <i className="ri-bookmark-line text-[#4db8b1] text-sm"></i>
              <span className="text-xs font-medium text-[#418b86]">{featured.category}</span>
            </div>

            <h2
              className="text-2xl md:text-4xl font-light text-[#2d2d2d] leading-snug mb-5"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {featured.title}
            </h2>

            <p className="text-[#6b6b6b] text-base leading-relaxed mb-6">
              {featured.excerpt}
            </p>

            <div className="flex items-center gap-4 text-[#9a9a9a] text-xs mb-8">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line text-sm"></i>
                {featured.date}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-sm"></i>
                {featured.readTime}
              </span>
            </div>

            <Link
              to={`/blog/${featured.id}`}
              className="inline-flex items-center gap-2 bg-[#418b86] hover:bg-[#4db8b1] text-white text-sm font-medium px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              Read the Article
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}